<div class="filterList" *ngIf="isFilterListOpen$()">
  <div class="divider"></div>
  <div class="filter-l">
    <ng-container *ngFor="let filter of filterList$ | async">
      <que-filter-type class="type" [filter]="filter"></que-filter-type>
    </ng-container>
  </div>
</div>